import React from 'react';
import {
  type AdminAnnouncementListItem,
  getAdminAnnouncements
} from '~/common/api-client';
import useAPI, { type State as BaseState } from '~/common/hooks/useAPI';

interface State extends Omit<BaseState<AdminAnnouncementListItem[]>, 'data'> {
  announcements: AdminAnnouncementListItem[];
  refresh: () => void;
}

const useAdminAnnouncements = (token: string): State => {
  const dataLoader = React.useCallback(
    () => getAdminAnnouncements(token),
    [token]
  );
  const state = useAPI(dataLoader);
  return {
    error: state.error,
    loading: state.loading,
    announcements: state.data || [],
    refresh: state.refresh
  };
};

export default useAdminAnnouncements;
